import React, { useState, useEffect } from 'react'

const Header = () => {
  const [scrolled, setScrolled] = useState(false)

  const handleScroll = () => {
    const offset = window.scrollY
    if (offset > 50) {
      setScrolled(true)
    } else {
      setScrolled(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-brand-bg/80 shadow-sm backdrop-blur-sm' : 'bg-transparent'}`}>
      <div className="container mx-auto px-6 py-5 flex justify-between items-center">
        <a href="#" className="text-2xl font-serif font-bold text-brand-green">
          Floricoltura Lampugnani
        </a>
        <nav className="hidden md:flex items-center space-x-8 text-brand-text">
          <a href="#benefits" className="hover:text-brand-green transition-colors">Vantaggi</a>
          <a href="#how-it-works" className="hover:text-brand-green transition-colors">Come Funziona</a>
          <a href="#faq" className="hover:text-brand-green transition-colors">FAQ</a>
        </nav>
      </div>
    </header>
  )
}

export default Header